import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {JsonSchema} from '../schema-form.types';
import {
  IFC_DATA_TYPE_GROUPS,
  knownDataTypes,
} from '../../../checks/bimCheck/components/ids/models/ifc-data-type-groups';

/** Vorschläge wie im IDS-Editor: erst die Gruppen („irgendeine Zahl" ist häufiger gefragt), dann die Typen. */
const VORSCHLAEGE: string[] = [
  ...IFC_DATA_TYPE_GROUPS.map(group => group.label),
  ...knownDataTypes(['IFC2X3', 'IFC4', 'IFC4X3']),
];

let naechsteListe = 0;

/**
 * IFC-Datentyp einer Eigenschaft (`x-widget: ifc-data-type`): freier Text mit Vorschlägen –
 * die Datentypengruppen des IDS-Editors (Text, Zahl, Ganzzahl, Wahrheitswert) und alle IFC-Datentypen.
 *
 * Gespeichert wird, was dasteht (z. B. „Zahl" oder „IfcLabel"); die Groß-/Kleinschreibung gleicht
 * die Auswertung aus, wie beim IDS-Editor (dort schreibt der Export das Token groß). Leer = kein
 * Datentyp (`null`), damit der Backend-Validator keinen leeren Text als Wert sieht.
 */
@Component({
  selector: 'sf-ifc-data-type',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <input
      type="text"
      [attr.list]="listId"
      [value]="value ?? ''"
      [placeholder]="placeholder"
      [disabled]="disabled"
      (change)="uebernehmen($any($event.target).value)"
      class="w-full h-[38px] px-3 text-sm text-gray-900 bg-gray-50 border border-gray-300 rounded-lg
             focus:outline-none focus:border-gray-400 focus:ring-2 focus:ring-gray-200 transition-colors"/>
    <datalist [id]="listId">
      @for (vorschlag of vorschlaege; track vorschlag) {
        <option [value]="vorschlag"></option>
      }
    </datalist>
  `,
})
export class SfIfcDataTypeComponent {
  @Input() schema: JsonSchema | null = null;
  @Input() value: any;
  @Input() disabled = false;
  @Output() valueChange = new EventEmitter<string | null>();

  protected readonly vorschlaege = VORSCHLAEGE;
  protected readonly listId = `sf-ifc-data-type-${naechsteListe++}`;

  get placeholder(): string {
    return this.schema?.['x-placeholder'] ?? 'z.B. IfcLabel oder Zahl';
  }

  uebernehmen(text: string): void {
    const wert = (text ?? '').trim();
    this.valueChange.emit(wert ? wert : null);
  }
}
